import { render, staticRenderFns } from "./LogsInstitucion.vue?vue&type=template&id=34b1df8e&"
import script from "./LogsInstitucion.vue?vue&type=script&lang=js&"
export * from "./LogsInstitucion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports